import { Component } from '@angular/core';

@Component({
    selector: 'app-light-loader',
    templateUrl: './light-loader.component.html',
    styleUrls: ['./light-loader.component.scss'],
    standalone: false
})
export class LightLoaderComponent {

  constructor() { }

}
